import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import Button from 'jbc-front/components/Button';
import { FormSubmitBtn } from 'src/buttons';
import CommonModal from 'jbc-front/components/CommonModal';
import { POLICY_FORM } from 'src/constants/FormNames';
import { getList, deleteCheckedUser } from 'src/reducers/users/roleUsers';
import styles from './DeletePolicyModal.scss';
import { useTranslation } from 'react-i18next';

const RawForm = ({ handleSubmit, submitting, submit, cancelBtnClick, header, numberOfUser }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <CommonModal.Header hideModal={cancelBtnClick}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <form onSubmit={handleSubmit}>
          <div>
            {t('features.RoleUsers.containers.DeletePolicyModal.delete_the_account_of')}{numberOfUser}{t('features.RoleUsers.containers.DeletePolicyModal.selected')}
          </div>
          <ul className={styles.notes}>
            <li>
              {t('features.RoleUsers.containers.DeletePolicyModal.deleting_an_account_does_not_delete_the_employee_information')}<br />{t('features.RoleUsers.containers.DeletePolicyModal.please_note_that_if_you_are_in_the_middle_of_an_input_request_the_request_will_be_canceled')}
            </li>
          </ul>
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={cancelBtnClick} className="u-mr20">
          {t('features.RoleUsers.containers.DeletePolicyModal.cancel')}
        </Button>
        <FormSubmitBtn text={t('features.RoleUsers.containers.DeletePolicyModal.delete')} {...{ submitting, submit }} />
      </CommonModal.Footer>
    </React.Fragment>
  );
};

let PolicyForm = reduxForm({
  form: POLICY_FORM
})(RawForm);

PolicyForm = connect(
  state => ({
    numberOfUser: _.get(_.filter(getList(state), { checked: true }), 'length')
  }),
  dispatch => ({
    onSubmit: () => dispatch(deleteCheckedUser())
  })
)(PolicyForm);

const DeletePolicyModal = ({ isOpen, hideModal }) => {
  const { t } = useTranslation();
  const header = t('features.RoleUsers.containers.DeletePolicyModal.delete_account');
  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <PolicyForm cancelBtnClick={hideModal} header={header} />
    </CommonModal>
  );
};

export default connect()(DeletePolicyModal);
